module.exports = __webpack_public_path__ + "app-static/img/icon-shsb.d74d148a.png";